#import "./drip-sequence-stub-fragment.graphql"
#import "../../../../../core/email-marketing/graphql/fragments/em-from-address-fragment.graphql"

fragment DripSequenceFragment on Campaign {
    ...DripSequenceStubFragment
    from {
        ...FromAddress
    }
    useUtmParameters
    utmParameters {
        source
        medium
    }
    defaultUtmParameters {
        source
        medium
    }
    isBusinessHoursOnly
    isStopOnGoal
    isStopOnLeadClose
    isStopOnRemovedFromAudience
    startTrigger {
        type
        id
        humanReadableTitle
        humanReadableSubtitle
    }
    goal {
        id
        type
        conditions {
            type
            config {
                ... on ConditionConfigEntityFilter {
                    filter {
                        ... on EntityFilterFieldConfigRelationship {
                            relationshipAnyAll
                            relationshipData
                        }
                        ... on EntityFilterFieldConfigEnum {
                            enumValue
                            enumIsNot
                        }
                    }
                }
                ... on ConditionConfigLink {
                    links
                }
                ... on ConditionConfigTag {
                    tags
                }
                ... on ConditionConfigAudience {
                    audiences
                }
            }
        }
        humanReadableTitle
        humanReadableSubtitle
        action {
            type
            humanReadableTitle
            humanReadableSubtitle
            config {
                isValid
                ... on ActionConfigAddTags {
                    tags {
                        id
                        name
                    }
                }
                ... on ActionConfigAddAudiences {
                    audiences {
                        id
                        name
                    }
                }
                ... on ActionConfigRemoveAudiences {
                    audiences {
                        id
                        name
                    }
                }
            }
        }
    }
    numInProgressDripProgressions
    customClickDomain {
        isVerified
    }
}
